import { authApiCall } from '../../../auth';

export const getCouponTransactions = (params = {}) => {
  // console.log('Calling API: /points/coupon-transactions/', { params });

  return authApiCall({
    url: '/points/coupon-transactions/',
    method: 'get',
  }); // Pass debug = true
};